module.exports = __webpack_public_path__ + "static/media/higher.cd651cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/higher.jpg
// module id = 246
// module chunks = 0